import './table.less';
import PropTypes from 'prop-types';
import React from 'react';
import cn from 'classname';
import { browserHistory } from 'react-router';
import noop from 'lodash/noop';

const Table = ({
	table,
	intl,
	sortByColumn,
	showMoreRows,
	updateInitialFormData,
	remove,
	can
}) => (
	<div className="table-container table-container--projector approved-reject-list-table">
		<div className="table-container--projector__body">
			<div className="table-container--projector__body-content">
				<table className="simple-table simple-table--static">
					<thead className="simple-table__head font-roboto-medium">
						<tr>
							{ table.headers.map((header, i) => (
								<th
									key={i}
									className={cn({
										'sort-header': header.direction,
										'active': table.sortedColumn.index === header.index,
										[header.className]: header.className,
										[table.sortedColumn.direction]: (
											table.sortedColumn.index === header.index && table.sortedColumn.direction
										)
									})}
									onClick={() => header.direction ? sortByColumn(header.index) : noop}>{intl(header.title)}</th>
							))}
						</tr>
					</thead>

					<tbody className="simple-table__body">
						{ table.rows.map((row, i) => (
							<tr key={i}>
								<td className="offer"><span>{ row.offer }</span></td>
								<td className="geo"><span>{ row.geo }</span></td>
								<td className="geo"><span>{ row.region_name }</span></td>
								<td className="geo"><span>{ row.district_name }</span></td>
								<td className="geo"><span>{ row.city_name }</span></td>
								<td className="affiliate"><span>{ row.affiliate }</span></td>
								<td className="usd_payout">{ row.usd_payout }</td>
								<td className="actions">
									{ can('geoPayoutRatesEdit') && (
										<a
											onClick={() => {
												updateInitialFormData(row);
												browserHistory.push('geo-payout-rates/edit');
											}}
											className="action_edit"
										/>
									) }

									{ can('geoPayoutRatesEdit') && (
										<a
											href="#"
											onClick={e => {
												e.preventDefault();
												confirm(`${
													intl('Delete geo payout rate')
												} ${row.geo} ${row.offer} ${row.affiliate}?`) && remove(row);
											}} className="action_delete" />

									) }
								</td>
							</tr>
						)) }
					</tbody>
				</table>
			</div>
		</div>

		<div className="table-container__navigation">
			{ table.totalRows > table.rowsNumber && (
				<button className="ui-btn ui-btn-secondary" onClick={() => showMoreRows()}>{intl('Show more')}</button>
			)}
		</div>
	</div>
);

Table.propTypes = {
	table: PropTypes.object,
	intl: PropTypes.func,
	sortByColumn: PropTypes.func,
	showMoreRows: PropTypes.func,
	remove: PropTypes.func,
	can: PropTypes.func
};

export default Table;



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/geo-payout-rates/components/table.js